//styled
import { About, Description, Hide, Image } from "../Styles";
//framer
import { motion } from "framer-motion";
import { animTitle, animTitle2, animTitle3, fade } from "../Animation";
import Wave from "./Wave"
//router
import {Link} from "react-router-dom"


export default function AboutSection() {
	
	return (
		<About>
			<Description>
				<div className="title">
					<Hide>
						<motion.h2 variants={animTitle} initial="hidden" animate="show">
							We train you to make{" "}
						</motion.h2>
					</Hide>
					<Hide>
						<motion.h2 variants={animTitle2} initial="hidden" animate="show">
							{" "}
							your <span>dreams</span>
						</motion.h2>
					</Hide>
					<Hide>
						<motion.h2 variants={animTitle3} initial="hidden" animate="show">
							come true.
						</motion.h2>
					</Hide>
				</div>
				<motion.p variants={fade}>Contact us for more information.</motion.p>
				<Link to="/contact">
				<motion.button variants={fade} initial="hidden" animate="show">Contact Us</motion.button>
				</Link>
			</Description>
			<Image>
				<img 
					src="https://image.winudf.com/v2/image/Y29tLkJoYXR0aUFwcHMua2l0YWIuSG90U2V4eVNwb3J0c19zY3JlZW5zaG90c18wXzdlOTRmYjE1/screen-0.jpg?fakeurl=1&type=.jpg"
					alt="trainer-pic"
				/>
			</Image>
			<Wave/>
			
		</About>
	);
}
